export const handleCreateFolder = (_$message, { commit, dispatch }) => {
    dispatch('addAndSaveMessage', {
        role: 'assistant',
        content: 'Happy to help. Where would you like to create the folder:',
        widgets: [
            {
                type: 'action_buttons',
                id: 'folder_section_select',
                buttons: [
                    { label: '1. Files',    action: 'create_folder:files',    variant: 'primary' },
                    { label: '2. Products', action: 'create_folder:products', variant: 'primary' },
                    { label: '3. Layouts',  action: 'create_folder:layouts',  variant: 'primary' },
                ],
            },
        ],
    });
};
